import {
  Container,
  Title,
  SubTitle,
  ButtonWrapper,
} from './AddEditCartItemModal.styled';
import { Modal } from '../Modal/Modal';
import Button from 'components/Button/Button';
import { useTranslation } from 'react-i18next';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { setActiveTab, setOrderProductsStep } from 'store/Order/actions/order';
import { OrderProductsSteps, OrderTabsEnum } from 'types/Order.types';
import { useDispatch, useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import {
  setTriggerShowAddedToCartModal,
  setTriggerShowCartItemEditedModal,
} from 'store/ShoppingCart/actions/shoppingCart';

export function AddEditCartItemModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isPhone } = useBreakpointFlag();
  const {
    triggerShowAddedToCartModal,
    triggerShowCartItemEditedModal,
    currentlyEditingShoppingCartLineId,
  } = useSelector((state: IRootReducerState) => state.shoppingCartInfo);

  const isOpen = triggerShowAddedToCartModal || triggerShowCartItemEditedModal;
  const isEditMode = !!currentlyEditingShoppingCartLineId;

  const handleClose = () => {
    if (isEditMode) {
      dispatch(setTriggerShowCartItemEditedModal(false));
    } else {
      dispatch(setTriggerShowAddedToCartModal(false));
    }
  };

  const handleConfigureNewProduct = () => {
    dispatch(setActiveTab(OrderTabsEnum.Products));
    dispatch(setOrderProductsStep(OrderProductsSteps.Selection));
    handleClose();
  };

  const handleProceedToOverview = () => {
    handleClose();
    dispatch(setActiveTab(OrderTabsEnum.Overview));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      modalStyle={{
        margin: 'auto',
        height: 'fit-content',
        width: isPhone ? '90%' : '600rem',
        minWidth: isPhone ? '90%' : 'auto',
        position: 'fixed',
      }}
      pwId="added-to-cart-modal"
    >
      <Container>
        <Title>
          {isEditMode
            ? t('The cart item was successfully edited')
            : t('The product was added to cart')}
        </Title>
        <SubTitle>
          {t(
            'Do you want to configure another product or continue to the overview'
          )}
          ?
        </SubTitle>
        <ButtonWrapper>
          <Button
            pwId="added-to-card-modal-configure-new-product"
            secondary
            label={t('Configure new product')}
            width="200rem"
            onClick={handleConfigureNewProduct}
          />
          <Button
            pwId="added-to-card-modal-proceed-to-cart"
            primary
            label={t('Proceed to overview')}
            width="200rem"
            onClick={handleProceedToOverview}
          />
        </ButtonWrapper>
      </Container>
    </Modal>
  );
}
